module.exports = __webpack_public_path__ + "media/images/icons/form_add_venue-ea5687218291ccc12546c50b4e953cf9.svg";